
export default function DatagridResumenCargo({ data, title, month, year }) {

    const sede = data[0]?.Sede.slice(7)
    
    return (
      <div className="px-4 sm:px-6 lg:px-8 bg-primarioMira p-5 rounded-lg">
        <div className="sm:flex sm:items-center">
          <div className="sm:flex-auto">
            <h1 className="text-lg font-semibold text-white">Resumen por cargo</h1>
            <h2 className="text-lg font-semibold text-white">{title} - Sede {sede}</h2>
            <h3 className="text-lg font-semibold text-white">{month} {year}</h3>
            <p className="mt-2 text-sm text-grisMira">
              Tabla resumen de todas las transacciones realizadas por usuario por empresa y sede especifica.
            </p>
          </div>
          {/*<div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
            <button
              type="button"
              className="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
            >
              Export
            </button>
          </div>*/}
        </div>
        <div className="mt-8 flex flex-col">
          <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-2 align-middle lg:px-6 lg:px-8">
              <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 lg:rounded-lg">
                <table className="min-w-full divide-y divide-gray-300">
                  <thead className="bg-secundarioMira">
                    <tr>
                      <th
                        scope="col"
                        className="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-grisMira sm:pl-6 sr-only"
                      >
                        ID
                      </th>
                      <th
                        scope="col"
                        className="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-grisMira"
                      >
                        Empresa
                      </th>
                      <th
                        scope="col"
                        className="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-grisMira"
                      >
                        Sede 
                      </th>
                      <th
                        scope="col"
                        className="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-white"
                      >
                        Cargo
                      </th>
                      <th
                        scope="col"
                        className="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-white"
                      >
                        Transacciones
                      </th>
                      <th scope="col" className="relative whitespace-nowrap py-3.5 pl-3 pr-4 sm:pr-6 font-semibold text-white">
                        Total por cargo
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-white bg-secundarioMira">
                    {data.map((transaction, index) => (
                      <tr key={index + 1}>
                        <td 
                            className={`whitespace-nowrap py-2 pl-4 pr-3 text-sm sm:pl-6 ${index < (data.length - 1) ? 'text-grisMira' : 'text-center text-white font-medium'}`}
                            colSpan={index < (data.length - 1) ? 1 : 2}
                        >
                          {index < (data.length - 1) ? null : 'TOTAL'}
                        </td>
                        <td className={`whitespace-nowrap px-2 py-2 text-sm text-grisMira ${index < (data.length - 1) ? null : 'hidden'}`}>
                          {index < (data.length - 1) ? transaction.Empresa : null}
                        </td>
                        <td className="whitespace-nowrap px-2 py-2 text-sm text-grisMira">{index < (data.length - 1) ? transaction.Sede : null}</td>
                        <td className="whitespace-nowrap px-2 py-2 text-sm text-white">{index < (data.length - 1) ? transaction.Cargo : null}</td>
                        <td className="whitespace-nowrap px-2 py-2 text-sm text-white">{index < (data.length - 1) ? transaction.Transacciones : null}</td>
                        <td className="whitespace-nowrap px-2 py-2 text-sm text-white">{index < (data.length - 1) ? transaction.Total : transaction.Total_Totales}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
  